import { Reveal } from "./Reveal";
import { Star } from "./Logo";
import { Camera, Sparkles, Sunrise } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";

const ICONS = [Camera, Sparkles, Sunrise];

export default function HowItWorks() {
  const { t } = useLang();
  return (
    <section id="how" className="mx-auto max-w-7xl px-5 sm:px-8 py-24 sm:py-36" data-testid="how-section">
      <Reveal>
        <p className="flex items-center gap-2 text-xs uppercase font-medium" style={{ color: "var(--camel)", letterSpacing: "0.16em" }}>
          <Star size={11} /> {t.how.kicker}
        </p>
        <h2 className="mt-5 max-w-2xl font-serif-display text-4xl sm:text-5xl font-semibold leading-tight" data-testid="how-title">
          {t.how.title}
        </h2>
      </Reveal>

      <div className="mt-16 grid grid-cols-1 gap-0 md:grid-cols-3 md:gap-12">
        {t.how.steps.map((step, i) => {
          const Icon = ICONS[i];
          return (
            <Reveal key={i} delay={i * 0.15} className="group border-t py-10 md:py-12" data-testid={`how-step-${i + 1}`}>
              <div style={{ borderColor: "var(--gold)" }}>
                <div className="flex items-baseline justify-between">
                  <span className="font-serif-display text-6xl sm:text-7xl font-medium" style={{ color: "var(--rose)" }}>
                    0{i + 1}
                  </span>
                  <Icon size={26} strokeWidth={1.5} className="transition-transform duration-500 group-hover:-translate-y-1" style={{ color: "var(--camel)" }} />
                </div>
                <h3 className="mt-6 font-serif-display text-2xl font-semibold">{step.title}</h3>
                <p className="mt-3 text-sm sm:text-base leading-relaxed" style={{ color: "var(--muted-warm)" }}>
                  {step.text}
                </p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </section>
  );
}
